import { render, staticRenderFns } from "./FontAwesomeIcon.vue?vue&type=template&id=be92c040&scoped=true"
import script from "./FontAwesomeIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./FontAwesomeIcon.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FontAwesomeIcon.vue?vue&type=style&index=0&id=be92c040&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be92c040",
  null
  
)

export default component.exports